import GenericDecimalValueComponent from './GenericDecimalValueComponent'
export default GenericDecimalValueComponent
